import gql from 'graphql-tag';

export const EMAIL_COMPETITION_WINNER = gql`
  mutation EmailCompetitionWinner($winnerId: ID!) {
    sendEmailNotifyWinner(winnerId: $winnerId) {
      success
    }
  }
`;
